import { type TFunction } from "i18next";

import { TermsAndConditionsTarget } from "@/constants";

import { type TermsAndConditionsText, type UserSummary } from "./types";

const SYSTEM_USER_LABEL = "System";

export const TARGET_VALUES = [
  TermsAndConditionsTarget.AGGREGATOR_ADMINS_FARMERS_TRADERS,
  TermsAndConditionsTarget.MASTERCARD_FOUNDATION_ADMINS,
  TermsAndConditionsTarget.MASTERCARD_FOUNDATION_PARTICIPANTS,
] as const;

const TARGET_TRANSLATION_KEYS: Record<string, string> = {
  [TermsAndConditionsTarget.AGGREGATOR_ADMINS_FARMERS_TRADERS]:
    "termsAndConditionsText.list.options.aggregatorsTradersAndFarmers",
  [TermsAndConditionsTarget.MASTERCARD_FOUNDATION_ADMINS]:
    "termsAndConditionsText.list.options.mastercardFoundationAdmins",
  [TermsAndConditionsTarget.MASTERCARD_FOUNDATION_PARTICIPANTS]:
    "termsAndConditionsText.list.options.mastercardFoundationParticipants",
};

export const getTargetLabel = (target: TermsAndConditionsText["target"], t: TFunction) => {
  const translationKey = target ? TARGET_TRANSLATION_KEYS[target] : undefined;

  return translationKey ? t(translationKey) : (target ?? "");
};

export const getFullName = (user?: UserSummary | null) =>
  [user?.first_name, user?.last_name]
    .map(name => name?.trim())
    .filter(Boolean)
    .join(" ") || SYSTEM_USER_LABEL;
